import { useAxios } from "./useAxios"
import { useOrganization } from "./useOrganization"

export type GetAllProductsParams = {
  integrations?: string[]
  perPage?: number | string
}

const apiRestAxios = useAxios(process.env.VUE_APP_API_REST_BASE_URL)

export function useProduct() {
  const { organization } = useOrganization()

  async function getAll(params?: GetAllProductsParams) {
    const response = await apiRestAxios.get(`/organizations/${organization.id}/products`, { params })

    return response.data
  }

  return {
    getAll
  }
}